import { Injectable } from '@angular/core';
import { LocalstorageService } from './../localstorage.service';
import { UserModel } from './../../model/userModel';

@Injectable()
export class SessionStorageService {

  constructor() { }

  public get getUserInfo(): any {
    if (LocalstorageService.isExist('ECt_user')) {
      return LocalstorageService.getValue('ECt_user');
    }
    return null;
  }

  public get getUserId(): any {
    if (LocalstorageService.isExist('ECt_user')) {
      return LocalstorageService.getValue('ECt_user').userId;
    }
    return null;
  }

  public get getUserCountryId(): any {
    if (LocalstorageService.isExist('ECt_user')) {
      return LocalstorageService.getValue('ECt_user').countryId;
    }
    return null;
  }

  public get getUserSchoolId(): any {
    if (LocalstorageService.isExist('ECt_user')) {
      return LocalstorageService.getValue('ECt_user').schoolId;
    }
    return null;
  }



  public get getUserRole(): any {
    if (LocalstorageService.isExist('ECt_user')) {
      return LocalstorageService.getValue('ECt_user').userRole;
    }
    return null;
  }

  // set
  public setUserInfo(userModel: any) {
    LocalstorageService.StoreValue('ECt_user', userModel);
  }

}
